module.exports = __webpack_public_path__ + "img/investment-dd-l3.17c9f2db.svg";